/**
 * Custom Graph Node Component
 *
 * Displays a node in the knowledge graph with styling based on node type
 */
import React, { memo } from 'react'
import { Handle, Position, NodeProps } from 'reactflow'
import { NodeType } from '@/types'

interface CustomNodeData {
  label: string
  nodeType: NodeType
  properties: Record<string, any>
  color: string
}

const CustomGraphNode: React.FC<NodeProps<CustomNodeData>> = memo(({ data, selected }) => {
  return (
    <div
      className={`px-4 py-2 shadow-md rounded-lg border-2 bg-white min-w-[120px] ${
        selected ? 'ring-2 ring-blue-500 ring-offset-2' : ''
      }`}
      style={{
        borderColor: data.color,
      }}
    >
      <Handle type="target" position={Position.Top} className="w-3 h-3" />

      <div className="flex flex-col">
        <div
          className="text-xs font-semibold uppercase tracking-wide mb-1"
          style={{ color: data.color }}
        >
          {data.nodeType}
        </div>
        <div className="text-sm font-medium text-gray-900 break-words">
          {data.label}
        </div>
        {Object.keys(data.properties).length > 0 && (
          <div className="mt-1 text-xs text-gray-500">
            {Object.keys(data.properties).length} properties
          </div>
        )}
      </div>

      <Handle type="source" position={Position.Bottom} className="w-3 h-3" />
    </div>
  )
})

CustomGraphNode.displayName = 'CustomGraphNode'

export default CustomGraphNode
